import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Component, Input }   from '@angular/core';
import { UIRouter }           from '@uirouter/angular';
import { TranslateService }   from '@ngx-translate/core';

import { CompanyService }           from '../../companies/company.service';
import { ConfirmService }           from '../confirm/confirm.service';
import { CustomerMessagesService }  from './customer-messages.service';
import { CompanyIntegrationsModel } from '../../companies/models/company.integrations';
import { MessagesService }          from '../messages.service';

@Component({
  selector   : 'wor-customer-messages-settings',
  template: require('./customer-messages.settings.component.html')
})

export class CustomerMessagesSettingsComponent {
  @BlockUI('customerMessagesSettingsBlock') block : NgBlockUI;

  @Input() quote    : any;
  @Input() settings : CompanyIntegrationsModel;
  @Input() session  : any;

  constructor(
    public  companyService         : CompanyService,
    private confirmService         : ConfirmService,
    private customerMessagesService: CustomerMessagesService,
    private messagesService        : MessagesService,
    private router                 : UIRouter,
    public translateService        : TranslateService,
  ) {}

  activate () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
      name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CUSTOMER_MESSAGES')
    }))
    .then(() => {
      this.block.start();
      return this.customerMessagesService.activateLookups();
    })
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CUSTOMER_MESSAGES')
      }), 'success');

      return this.router.stateService.reload();
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

  deactivate () : void {
    this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.REMOVE_INTEGRATION', {
      name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CUSTOMER_MESSAGES')
    }))
    .then(() => {
      this.block.start();
      return this.customerMessagesService.deactivateLookups();
    })
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.REMOVED_INTEGRATION', {
        name: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.CUSTOMER_MESSAGES.CUSTOMER_MESSAGES')
      }), 'success');

      return this.router.stateService.reload();
    })
    .catch(( err : any ) => {
      this.messagesService.error(err);
    })
    .finally(() => {
      this.block.stop();
    });
  }

}